export default "__VITE_ASSET__b10c2434__"